// extracted by mini-css-extract-plugin
module.exports = {"title":"BigSliderItem_title__3krt8","text":"BigSliderItem_text__CMum8","img":"BigSliderItem_img__tFka2","imgWrap":"BigSliderItem_imgWrap__2BffT","tags":"BigSliderItem_tags__1j5By"};